import React from 'react';
import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import styles from './UpgradeDisclaimer.module.scss';
import { appEnv } from '../../../../utils/env';

export const UPGRADE_DISCLAIMER_CONTAINER = 'upgrade-disclaimer-container';
const UpgradeDisclaimer = () => {
  const { upgradeToAnnualMembership } = DISCLAIMER_NAMES;

  return (
    <div
      className={styles.upgradeDisclaimerContainer}
      data-testid={UPGRADE_DISCLAIMER_CONTAINER}
    >
      <Disclaimer name={upgradeToAnnualMembership} env={appEnv} />
    </div>
  );
};

export default UpgradeDisclaimer;
